import { IonChip, IonLabel } from '@ionic/react'
import { useStore } from 'effector-react'
import { $bookingCar } from '~/features/BookingCars/BookingCar/model'
import { BookingCarDrawer } from '~/entities/BookingCar'
import { UnAuthProposalRegistrationDrawer } from '~/entities/Registration'
import { Button } from '~/shared/ui/Buttons'
import { useDrawer } from '~/shared/ui/Drawer'
import {
  BookingPhone,
  BookingPhoneDescriptions,
  BookingPhoneTitle,
  BookingPhoneWrapper,
} from './styled'

export function BookingUnAuth() {
  const [isBookingCarDrawerShow, openBookingCarDrawer, closeBookingCarDrawer] =
    useDrawer()

  const [
    isBookingCarRegisterDrawerShow,
    openBookingCarRegisterDrawer,
    closeBookingCarRegisterDrawer,
  ] = useDrawer()

  const bookingCar = useStore($bookingCar)
  const cancellationFeeRub = bookingCar?.getCancellationFeeRub()

  const location = bookingCar?.getLocation()
  const taxiparkId = bookingCar?.getTaxipark()?.getApiId()

  return (
    <>
      <Button
        variant='limeFlooded'
        size='large'
        fullWidth
        onClick={openBookingCarDrawer}
        data-testid='button-booking-car-drawer'
      >
        Забронировать на 2 часа
      </Button>

      <BookingCarDrawer
        isShow={isBookingCarDrawerShow}
        onCancel={closeBookingCarDrawer}
        location={location}
        cancellationFeeRub={cancellationFeeRub}
      >
        <IonChip color='secondary' style={{ marginBottom: '16px' }}>
          <IonLabel>
            Вам необходимо разово пройти процедуру проверки и регистрации в
            офисе, чтобы аренда стала доступна. Подробности можете уточнить по
            телефону
          </IonLabel>
        </IonChip>

        <BookingPhoneWrapper href='tel:+79344770800'>
          <BookingPhoneTitle>Аренда авто по телефону:</BookingPhoneTitle>
          <BookingPhone>+7 (934) 477-08-00</BookingPhone>
          <BookingPhoneDescriptions>
            В Москве офис работает по будням 9:00–18:00 и в сб 10:00–16:00; в
            регионах — по будням 9:00–18:00, выходные — сб и вс.
          </BookingPhoneDescriptions>
        </BookingPhoneWrapper>

        <Button
          size='large'
          data-testid='button-booking-car-drawer'
          fullWidth
          variant='limeFlooded'
          style={{ marginBottom: '8px' }}
          onClick={openBookingCarRegisterDrawer}
        >
          Забронировать
        </Button>
      </BookingCarDrawer>

      <UnAuthProposalRegistrationDrawer
        isShow={isBookingCarRegisterDrawerShow}
        onCancel={closeBookingCarRegisterDrawer}
        taxiparkId={taxiparkId}
        descriptions='И стань частью комьюнити профессиональных водителей'
        registrationType='full'
      />
    </>
  )
}
